import { AbstractCommand } from 'src/models/command';
import { Mail } from 'src/models/mail';

class MailDeleteCommand extends AbstractCommand {
	readonly name = 'IFS_Desktop_Command_Command_Desktop_Actions_DeleteTheSelectedAggregateIds';

	public constructor(mail: Mail, processId: string) {
		super();
		this.processId = processId;
		this.parameters = {
			aggregateIds: [mail.aggregateId],
		};
	}
}

export { MailDeleteCommand };
